import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const validationSchema = (t: TFunction) =>
  Yup.object({
    name: Yup.string()
      .max(100, t('valid_err_max', { max: 100 }))
      .required(t('valid_err_required')),
    type: Yup.string().required(t('valid_err_required')),
    // description: Yup.string()
    //   .max(250, t('valid_err_max', { max: 250 }))
    //   .required(t('valid_err_required')),
    color: Yup.string().required(t('valid_err_required')),
    active: Yup.string().required(t('valid_err_required')),
  });

export type ManageTagValidationSchemaType = ReturnType<typeof validationSchema>;
